module.exports = new __parcel__URL__("load_text_2.f16e0fa0.png").toString();